/**
 * The container for the section "Get Started" in the home page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025-2026
 */

import { AppRouteUrl } from '@/AppRoute'
import GetStartedComp from './GetStartedComp'

const ICON_SET_DIR = '/icon/set/png_stroke/1x'

const GetStartedContainer = () => {
  const api_documentation_url = new URL(
    'api',
    import.meta.env.VITE_API_DOCS_BASE_URI
  ).href

  return (
    <div className="getStartedContainer">
      <GetStartedComp
        icon={`${ICON_SET_DIR}/black/5-Assets.png`}
        title={'API Explorer'}
        link_description={'Review the documentation'}
        link_url={api_documentation_url}
      ></GetStartedComp>

      <GetStartedComp
        icon={`${ICON_SET_DIR}/black/36-Match.png`}
        title={'Tokens'}
        link_description={'Manage API credentials'}
        link_url={AppRouteUrl.ApiKey}
      ></GetStartedComp>
    </div>
  )
}

export default GetStartedContainer
